// THINK: Check all the switches in codebase
export class UnreachableCaseError extends Error {
    constructor(val, message = "Unreachable case:") {
        super(`${message} ${JSON.stringify(val)}`);
    }
}
